import Vue from 'vue'
import Router from 'vue-router'
import App from '@/App'
import login from '@/components/login'
import index from '@/components/index'
import teamList from '@/components/team/teamList'
import teamEdit from '@/components/team/teamEdit'
import teamCreate from '@/components/team/teamCreate'
import transactionList from '@/components/transaction/transactionList'
import transaction from '@/components/transaction/transaction'
import bill from '@/components/bill/bill'

Vue.use(Router)
let router = new Router({
  routes: [
    {
      path: '/',
      component: App,
      children: [
        {
          path: 'login',
          name: 'login',
          component: login
        },
        {
          path: 'index',
          name: 'index',
          component: index,
          children: [
            {
              path: 'teamList',
              name: 'teamList',
              component: teamList,
              meta: { keepAlive: true },
              children: [
                {
                  path: ':id',
                  name: 'teamEdit',
                  component: teamEdit,
                  meta: { keepAlive2: true }
                }
              ]
            },
            {
              path: 'teamCreate',
              name: 'teamCreate',
              component: teamCreate
            },
            {
              path: 'bill',
              name: 'bill',
              component: bill
            },
            {
              path: 'transactionList',
              name: 'transactionList',
              component: transactionList,
              meta: { keepAlive: true },
              children: [
                {
                  path: ':id',
                  name: 'transaction',
                  component: transaction
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})

router.beforeEach(({meta, path}, from, next) => {

  let token = localStorage.getItem('token')
  console.log(path,token)
  if(!token && path !== '/login')
    return next({ name: 'login' })
  else if (token && (path === '/' || path === '/login'))
    return next({ name: 'index' })
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js